import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import Cookies from 'js-cookie';
var TokenKey = 'access_token';
var RefreshTokenKey = 'refresh_token';
var UserId = 'user_id';
// const domain = location.href.includes(process.env.VUE_APP_domain)
//   ? process.env.VUE_APP_domain : null; // 非常重要   设置错误 无法跳转页面  没有报错
var href = window.location.hostname;
export var isLocal = href.includes('localhost');
var domain = isLocal ? null : process.env.VUE_APP_DOMAIN || href;
export function getToken() {
  return Cookies.get(TokenKey);
}
export function setToken(token) {
  return Cookies.set(TokenKey, token, {
    domain: domain
  });
}
export function removeToken() {
  return Cookies.remove(TokenKey, {
    domain: domain
  });
}
export function getRefreshToken() {
  return Cookies.get(RefreshTokenKey);
}
export function setRefreshToken(time) {
  return Cookies.set(RefreshTokenKey, time, {
    domain: domain
  });
}
export function removeRefreshToken() {
  return Cookies.remove(RefreshTokenKey, {
    domain: domain
  });
}
export function setIat(iat) {
  return Cookies.set('iat', iat, {
    domain: domain
  });
}
export function setUserInfo(user) {
  return Cookies.set('userInfo', user, {
    domain: domain
  });
}
export function setExp(exp) {
  return Cookies.set('exp', exp, {
    domain: domain
  });
}
export function setPer(list) {
  // return Cookies.set('permission_list', list, {
  //   domain,
  // });
  return localStorage.setItem('permission_list', list);
}
export function getPer() {
  // return Cookies.get('permission_list') || ''; // 没有值返回空
  return localStorage.getItem('permission_list') || '';
}
export function setBaseurl(url) {
  // return Cookies.set('system_baseUrl', url, {
  //   domain,
  // });
  return localStorage.setItem('system_baseUrl', url);
}
export function getBaseurl() {
  // return Cookies.get('system_baseUrl') || ''; // 没有值返回空
  return localStorage.getItem('system_baseUrl') || '';
}
export function getUserId() {
  return Cookies.get(UserId);
}
export function setUserId(id) {
  return Cookies.set(UserId, id, {
    domain: domain
  });
}
export function setFirstBranch(firstBranch) {
  return Cookies.set('firstBranch', firstBranch, {
    domain: domain
  });
}
export function getFirstBranch() {
  return Cookies.get('firstBranch');
}
export function setOrgId(orgId) {
  return Cookies.set('orgId', orgId, {
    domain: domain
  });
}
export function getOrgId() {
  return Cookies.get('orgId');
}
export function removeUserId() {
  return Cookies.remove(UserId, {
    domain: domain
  });
}
export function setPermissionList(list) {
  return Cookies.set('PermissionList', list, {
    domain: domain
  });
}
export function removePermissionList() {
  return Cookies.remove('PermissionList', {
    domain: domain
  });
}
export function setTheme(theme) {
  return Cookies.set('theme_name', theme, {
    domain: domain
  });
}